import { useContext, useEffect, useMemo } from "react";
import { useNavigate } from "react-router";
import { AuthContext } from "../context/AuthContext";

const usePermissions = ({ key, redirectPermissions = [] }) => {
  const { userProfile } = useContext(AuthContext);

  const navigate = useNavigate();
  const permissions = useMemo(() => {
    const storedPermissions =
      JSON.parse(localStorage.getItem("permission") || "{}")?.permissions || [];
    console.log("storedPermissions", storedPermissions);

    return storedPermissions.reduce(
      (acc, { permissionKey, isView, ...per }) => {
        if (isView) {
          if (!acc[permissionKey]) {
            acc[permissionKey] = { isView };
          }
          acc[permissionKey] = { ...acc[permissionKey], ...per };
        }
        return acc;
      },
      {}
    );
  }, []);
  const isAdmin = userProfile?.role === "admin";
  useEffect(() => {
    redirectPermissions.forEach((permissionType) => {
      if (!isAdmin && !hasPermission(key, permissionType)) {
        navigate("/");
      }
    });
  }, [isAdmin, key, redirectPermissions, navigate, permissions]);

  if (!key) {
    return { isView: false, isAdd: false, isEdit: false, isDelete: false };
  }

  const hasPermission = (permissionKey, permissionType) => {
    const assignedPermissions = permissions[permissionKey] || {};
    const hasPermission = assignedPermissions[permissionType];
    return hasPermission;
  };

  const isView = isAdmin || hasPermission(key, "isView");
  const isAdd = isAdmin || hasPermission(key, "isAdd");
  const isEdit = isAdmin || hasPermission(key, "isEdit");
  const isDelete = isAdmin || hasPermission(key, "isDelete");

  return { isView, isAdd, isEdit, isDelete };
};

export default usePermissions;
